import React from 'react';
import { COLORS } from '../../utils/constants';

const FormInput = ({ 
  label, 
  type = "text", 
  placeholder, 
  value, 
  onChange,
  name,
  required = false,
  disabled = false
}) => {
  return (
    <div style={{ marginBottom: '20px', width: '100%' }}>
      <label 
        htmlFor={name}
        style={{
          display: 'block',
          marginBottom: '8px',
          fontSize: '14px',
          fontWeight: '500',
          color: COLORS.black,
          opacity: disabled ? 0.6 : 1
        }}
      >
        {label}
      </label>
      <input
        id={name}
        name={name}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        required={required}
        disabled={disabled}
        style={{
          width: '100%',
          padding: '14px 16px',
          fontSize: '15px',
          border: `2px solid ${COLORS.lightGray}`,
          borderRadius: '12px',
          outline: 'none',
          transition: 'all 0.3s ease',
          fontFamily: 'inherit',
          backgroundColor: disabled ? '#f5f5f5' : COLORS.white,
          boxSizing: 'border-box',
          cursor: disabled ? 'not-allowed' : 'text',
          opacity: disabled ? 0.6 : 1
        }}
        onFocus={(e) => {
          if (!disabled) {
            e.target.style.borderColor = COLORS.blue;
            e.target.style.boxShadow = `0 0 0 1px ${COLORS.blue}`;
          }
        }}
        onBlur={(e) => {
          if (!disabled) {
            e.target.style.borderColor = COLORS.lightGray;
            e.target.style.boxShadow = 'none';
          }
        }}
      />
    </div>
  );
};

export default FormInput;